import React, { useMemo } from "react";
import ReactSVGIcon from "@micado-digital/react-svg-icon/ReactSVGIcon";

import styles from "./Tag.styles";

const Tag = ({ tag }) => {
	const { REACT_APP_PATH } = process.env;
	const css = styles();

	const icon = useMemo(() => {
		switch (tag) {
			case "crown":
				return <ReactSVGIcon src={`${REACT_APP_PATH}/img/icons/shop/crown.svg`} size={50} />;
			case "hand":
				return <ReactSVGIcon src={`${REACT_APP_PATH}/img/icons/shop/hand.svg`} size={40} />;
			case "heart":
				return <ReactSVGIcon src={`${REACT_APP_PATH}/img/icons/shop/heart.svg`} size={40} />;
			default:
				return;
		}
	}, [REACT_APP_PATH, tag]);

	return <div className={css.tag}>{icon}</div>;
};

export default Tag;
